import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Home.css";
import { useAppContext } from "../../contexts/AppContext";
import Loading from "../Loading/Loading";
import parse from "html-react-parser";

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { backendUrl, translate, getImageUrl, homeContent } = useAppContext();
  const [mobile, setMobile] = useState([]);

  const mobileRoute = "/CallUs";

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axios.get(`${backendUrl}${mobileRoute}`);
        if (Array.isArray(response?.data)) {
          setMobile(response?.data);
        }
      } catch (error) {
        console.error("Error fetching mobile info:", error);
      }
    };
    fetchdata();
  }, [backendUrl]);

  useEffect(() => {
    if (!homeContent || !Array.isArray(homeContent.images) || homeContent.images.length <= 1) {
      return;
    }
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % homeContent.images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [homeContent]);

  if (!homeContent) {
    return <Loading />;
  }

  const renderText = (text) => {
    if (!text) return "";
    try {
      return parse(translate(text));
    } catch (e) {
      return text;
    }
  };

  return (
    <div className="home-hero-section " id="home">
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          {/* Text Content */}
          <div className="col-lg-6 col-md-12 text-content-wrapper animate__animated animate__fadeInLeft">
            <h1 className="main-hero-title">
              {renderText(homeContent.homeTitle)}
            </h1>
            <p className="main-hero-description">
              {renderText(homeContent.homeMessage)}
            </p>

            <div className="hero-actions">
              {Array.isArray(mobile) && mobile.length > 0 && (
                <a
                  href={`tel:${mobile[0]?.mobile}`}
                  className="btn-hero-primary shadow"
                >
                  <i className="bi bi-telephone-fill me-2"></i>
                  {translate("Call Now")}
                </a>
              )}
              <button
                className="btn-hero-secondary"
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              >
                {translate("Our Services")}
              </button>
            </div>
          </div>

          {/* Image Slider */}
          <div className="col-lg-6 col-md-12 image-content-wrapper animate__animated animate__fadeInRight">
            <div className="hero-image-container">
              {Array.isArray(homeContent?.images) && homeContent.images.length > 0 && (
                <img
                  key={currentIndex}
                  className="hero-main-img animate__animated animate__fadeIn"
                  src={getImageUrl(homeContent.images[currentIndex])}
                  alt="Dermatology"
                />
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
